export enum Applicant {
	MAIN = 'MAIN',
	CO = 'CO'
}

export namespace Applicant {
	export function toDisplayText(applicant: Applicant): string {
		switch (applicant) {
			case Applicant.MAIN:
				return 'Main applicant';
			case Applicant.CO:
				return 'Co applicant';
			default:
				return applicant;
		}
	}
}
